import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubHeResearchInitiativeHeroHeaderCustomCls: string;
			heHubHeResearchInitiativeHeroHeaderTopCls: string;
			heHubHeResearchInitiativeHeroLayoutItemCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub He Research Initiative Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroHeaderCustomCls || '', 'he_hub_he_research_initiative_hero', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroHeaderTopCls || '', 'he_hub_he_research_initiative_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroLayoutItemCls + '1', 'he_hub_he_research_initiative_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroLayoutItemCls + '2', 'he_hub_he_research_initiative_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroLayoutItemCls + '3', 'he_hub_he_research_initiative_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeHeroLayoutItemCls + '4', 'he_hub_he_research_initiative_hero', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;